import React from "react"
import "./Landing.css"

import CompanyLogoOnlySVG from "../assets/svg/logo/company logo only.svg"
import CompanyLogoTextOnlySVG from "../assets/svg/logo/company logo text only.svg"
// import VisionFrameSVG from "../assets/svg/frame/vision frame (updated).svg"
// import VisionFrameCornerSVG from "../assets/svg/frame/vision frame (corner).svg"
// import VisionFrameTopSVG from "../assets/svg/frame/vision frame (top).svg"
import VisionWordsSVG from "../assets/svg/frame/vision words.svg"
import NimbleIconSVG from "../assets/svg/values/Be Nimble icon.svg"
import EmpathyInclusionIconSVG from "../assets/svg/values/Empathy _ Inclusion icon.svg"
import NurtureIconSVG from "../assets/svg/values/Nurture each other icon.svg"
import OlympicSpiritIconSVG from "../assets/svg/values/Olympic Spirit icon.svg"
import PlayerDevotedIconSVG from "../assets/svg/values/Player Devoted icon.svg"
import PositiveImpactIconSVG from "../assets/svg/values/Positive Impact icon.svg"
import ShipGoodIconSVG from "../assets/svg/values/Ship Good icon.svg"
// import FacebookIconSVG from "../assets/svg/social/facebook logo.svg"
// import InstagramIconSVG from "../assets/svg/social/instagram logo.svg"
// import LinkedinIconSVG from "../assets/svg/social/linkedin logo.svg"
// import TwitterIconSVG from "../assets/svg/social/twitter logo.svg"
import EmailIconSVG from "../assets/svg/icons/mail.svg"
// import SocialMediaLine1SVG from "../assets/svg/frame/social media line 1.svg"
import SocialMediaLine2SVG from "../assets/svg/frame/social media line 2.svg"
import SocialLogoSVG from "../assets/svg/logo/social media amihan logo.svg"

import AndresWEBP from "../assets/portraits/Andres.webp"
import CamiloWEBP from "../assets/portraits/Camilo.webp"
import BrianWEBP from "../assets/portraits/Brian.webp"
import CharlieWEBP from "../assets/portraits/Charlie.webp"
import JasWEBP from "../assets/portraits/Jas.webp"
import KennyWEBP from "../assets/portraits/Kenny.webp"
import PanchoWEBP from "../assets/portraits/Pancho.webp"
import PaulWEBP from "../assets/portraits/Paul.webp"
import PeiSanWEBP from "../assets/portraits/Pei San.webp"
import VickiWEBP from "../assets/portraits/Vicki.webp"
import TomWEBP from "../assets/portraits/Tom.webp"
import GeorgeWEBP from "../assets/portraits/George.webp"
import TimWEBP from "../assets/portraits/Tim.webp"

import SVG from "react-inlinesvg"

const TeamMember: React.FC<{
    portrait: string
    name: string
    subtext: string
    link?: string
}> = (props) => {
    return (
        <div className="team-member">
            <img className="portrait" src={props.portrait} alt={props.name} width="735" height="982" />
            
            <a href={props.link}>
                <h1 className="name">{props.name}</h1>
            </a>

            <h2 className="position">{props.subtext}</h2>
        </div>
    )
}

export const Landing: React.FC = () => {
    return (
        <main id="landing">
            <header>
                <SVG src={CompanyLogoOnlySVG} />
                <SVG src={CompanyLogoTextOnlySVG} />
            </header>

            <div id="vision">
                <p>
                    <SVG src={VisionWordsSVG} />
                    <span>
                        Welcome to Amihan! We are a progressive game studio aiming to redefine both what it means to be a developer and a player in today’s connected world. Our vision is to equalize opportunity for all through games. We champion diversity because empathy empowers us to best serve the next gamer generation. If uplifting and enriching the lives of others calls to you, our party eagerly awaits its next adventurer. Join us as we build our first game, <a href="https://www.everseed.com">Everseed</a>, together!
                    </span>
                </p>
            </div>

            <div id="values">
                <div>
                    <SVG src={NimbleIconSVG} />
                    <h1>Be Nimble</h1>
                    <p>Open-minded and quick-witted, we spring into action, adapting to and solving whatever problems emerge in front of us.</p>
                </div>
                <div>
                    <SVG src={PlayerDevotedIconSVG} />
                    <h1>Player Devoted</h1>
                    <p>Dedicated to the next gamer generation, we want to deliver joy and value to billions around the world.</p>
                </div>
                <div>
                    <SVG src={PositiveImpactIconSVG} />
                    <h1>Nurture Each Other</h1>
                    <p>We root for and cultivate one another so that we may grow and bloom together.</p>
                </div>
                <div>
                    <SVG src={OlympicSpiritIconSVG} />
                    <h1>Embody the Olympic Spirit</h1>
                    <p>Each day presents a new opportunity to change for the better. We embrace excellence as a process of steadfast commitment and humility.</p>
                </div>
                <div>
                    <SVG src={EmpathyInclusionIconSVG} />
                    <h1>Uphold Empathy &amp; Inclusion</h1>
                    <p>We champion and defend diversity: it is our unique superpower that uplifts our creativity.</p>
                </div>
                <div>
                    <SVG src={ShipGoodIconSVG} />
                    <h1>Ship Good &amp; Iterate to Great</h1>
                    <p>We ship, listen, learn, improve, and ship again. We build towards greatness together with our community.</p>
                </div>
                <div>
                    <SVG src={NurtureIconSVG} />
                    <h1>Leave a Positive Impact</h1>
                    <p>We must leave the world a better place than how we found it. Doing well is meaningless without also doing good.</p>
                </div>
            </div>

            <div id="team">
                <div>
                    <TeamMember portrait={KennyWEBP} name="Kenneth Liu" subtext="CEO (he/him)" link="https://www.linkedin.com/in/kliuless/" />
                    <TeamMember portrait={PaulWEBP} name="Paul Loy" subtext="CTO (he/him)" link="https://www.linkedin.com/in/paulloy/" />
                    <TeamMember portrait={JasWEBP} name="Jaslynn Tham" subtext="Lead Artist (she/her)" link="https://www.artstation.com/jastham"/>
                    <TeamMember portrait={TimWEBP} name="Tim Crosby" subtext="Principal Game Designer (he/him)" link="https://www.linkedin.com/in/tim-crosby-34890a/" />
                    <TeamMember portrait={GeorgeWEBP} name="George Skleres" subtext="Lead Game Designer (he/him)" link="https://www.linkedin.com/in/gskleres/"/>
                    <TeamMember portrait={PeiSanWEBP} name="Pei San Tan" subtext="Software Engineer (she/her)" link="https://www.linkedin.com/in/pei-san-tan-580751b7/"/>
                    <TeamMember portrait={CharlieWEBP} name="Charlie Roselius" subtext="Senior Software Engineer (they/them)" link="https://www.linkedin.com/in/charlie-roselius/"/>
                    <TeamMember portrait={AndresWEBP} name="Andres Sweeney-Rios" subtext="Software Engineer (he/him)" link="https://www.linkedin.com/in/andres-sweeney-rios-281495158/"/>
                    <TeamMember portrait={VickiWEBP} name="Vicki Quek" subtext="Artist (she/her)" link="https://www.artstation.com/vickiquek"/>
                    <TeamMember portrait={CamiloWEBP} name="Camilo Hoyos" subtext="Software Engineer (he/him)" link="https://www.linkedin.com/in/camilohoyos16/"/>
                    <TeamMember portrait={PanchoWEBP} name="Pancho Vasquez" subtext="Artist (he/him)" link="https://www.artstation.com/fvr" />
                </div>
            </div>

            <footer id="contact">
                {/* <h2>Stay connected with us.</h2> */}

                {/* <div id="social">
                    <a href="#"><SVG src={FacebookIconSVG} /></a>
                    <a href="#"><SVG src={InstagramIconSVG} /></a>
                    <a href="#"><SVG src={TwitterIconSVG} /></a>
                    <a href="#"><SVG src={LinkedinIconSVG} /></a>
                </div> */}

                <a href="https://everseed.com/" style={{
                    textDecoration: 'underline',
                    marginBottom: '60px',
                    maxWidth: '80vw',
                    textAlign: 'center',
                }}><h1>Click here to download and play our first game, Everseed!</h1></a>

                <a id="contact-email" href="mailto:contact@amihan.gg" target="_blank" rel="noreferrer">
                    <SVG src={EmailIconSVG} />
                    contact@amihan.gg
                </a>

                {/* <SVG className="social-line-1" src={SocialMediaLine1SVG} /> */}

                <SVG className="social-logo" src={SocialLogoSVG} />

                <h1 className="copyright">© 2021 Amihan Entertainment</h1>
                <h1 className="copyright">All Rights Reserved</h1>

                <SVG className="social-line-2" src={SocialMediaLine2SVG} />
            </footer>
        </main>
    )
}